import React, { memo } from 'react';
import { Dot, MarkerWrapper, MarkerContainer } from './styled';
import { Marker } from '../types';

export interface ItemsMapMarkerOverlayProps {
  marker: Marker;
  isActive: boolean;
  onMarkerClick: (value: Marker) => void;
}

export const ItemsMapMarker: React.FC<ItemsMapMarkerOverlayProps> = memo(
  ({ marker, isActive, onMarkerClick }) => {
    const handleClick = (e: React.MouseEvent) => {
      e.stopPropagation();
      onMarkerClick(marker);
    };

    return (
      <MarkerContainer onClick={handleClick} $isActive={isActive}>
        <Dot />
        <MarkerWrapper role="button">{marker.label}</MarkerWrapper>
      </MarkerContainer>
    );
  }
);

ItemsMapMarker.displayName = 'ItemsMapMarker';
